import type { EsignApiTyped } from './types';

import './setup';
import { esignApiRoot } from './root';

export const esign = esignApiRoot as EsignApiTyped;
